import {deskRename} from './deskRename.js'
import {partsTypeDirective} from './partsTypeDirective.js'
import {reactIconsV3} from './reactIconsV3.js'

export const codemods = {
  deskRename,
  partsTypeDirective,
  reactIconsV3,
}
